import { Button, Divider } from "antd";
import React, { Fragment } from "react";

function CardAction({ agentId }) {
  return (
    <Fragment>
      <Button
        data-testid="uploaded-docs-edit"
        aria-label="Edit Uploaded Documents"
        type="link"
        target="_blank"
        href={`/admin/documents/${agentId}`}
      >
        Edit
      </Button>
      <Divider type="vertical" />
      <Button
        data-testid="uploaded-docs-view"
        type="link"
        target="_blank"
        href={`/documents/${agentId}`}
      >
        View
      </Button>
    </Fragment>
  );
}

export { CardAction };
